import { Col, Descriptions, Row, Input, Table, Tag, Tooltip } from 'antd';
import React from 'react';
import { isEmpty } from 'lodash';
import { printInfo } from 'store/appTrack/utils';
import { useSelector } from 'react-redux';
import { isForeign } from 'utils';
const { TextArea } = Input;

const BasicInfo = () => {
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);
  const user = useSelector(state => state.user);

  const response =
    Object.keys(apptrackDetails?.variablesIndexed).length === 1 &&
    apptrackDetails?.variablesIndexed.hasOwnProperty('initiator')
      ? apptrackDetails?.localTaskVariables
      : apptrackDetails?.variablesIndexed;

  const getSupplementaryKads = () => {
    if (response?.getAllKadBranchesReturn?.kadFirmList?.kadFirmRecord) {
      return response.getAllKadBranchesReturn.kadFirmList.kadFirmRecord
        .filter(record => record.firmActKind !== '1')
        .map(record => `${record.firmActivity} - ${record.firmDescr}`)
        .join(',\n');
    }
    return null;
  };

  const supplementaryKads = getSupplementaryKads();

  const carrierUsersColumns = [
    {
      title: 'Επωνυμία / Ονοματεπώνυμο',
      dataIndex: 'userLName',
      key: '1',
      width: 280,
      render: text => printInfo(text),
    },
    {
      title: 'Τηλέφωνο Επικοινωνίας',
      dataIndex: 'userPhone',
      key: '2',
      width: 280,
      render: text => printInfo(text),
    },
    {
      title: 'E-mail Επικοινωνίας',
      dataIndex: 'userEmail',
      key: '3',
      width: 600,
      render: text => printInfo(text),
    },
  ];

  const bankDetailsSource = [
    {
      key: '1',
      description: 'Πιστωτικό Ίδρυμα',
      value: response?.bnkBank,
    },
    {
      key: '2',
      description: 'IBAN',
      value: response?.beneficiaryIban,
    },
  ];

  const bankDetailsColumns = [
    {
      title: 'Στοιχεία Πιστωτικού Ιδρύματος',
      dataIndex: 'description',
      key: '1',
      render: text => printInfo(text),
    },
    {
      title: '',
      dataIndex: 'value',
      key: '2',
      render: text => printInfo(text),
    },
  ];

  // function gia na kanoyme truncation
  const TruncatedURL = ({ url }) => {
    if (!url) return '-';

    return (
      <Tooltip title={url} placement="topLeft">
        <div
          style={{
            width: '300px',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'block',
          }}
        >
          {url}
        </div>
      </Tooltip>
    );
  };

  return (
    <div className="" style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex' }}>
        <div
          style={{
            width: '49%',
            marginRight: '2%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Descriptions
            title="Στοιχεία Αίτησης"
            bordered
            className="large-titles-purple-responsive investment-plan-details-table"
            style={{ flex: 1 }}
            column={1}
          >
            <Descriptions.Item label="Επωνυμία Προμηθευτή">
              {printInfo(response.companyName)}
            </Descriptions.Item>
            <Descriptions.Item label="Α.Φ.Μ.">
              {printInfo(response.abiVat)}
            </Descriptions.Item>
            <Descriptions.Item label="ΚΑΔ Κύριας Δραστηριότητας">
              {response?.isForeignSupplier ? 
                printInfo(response?.mainKAD)
              : printInfo(response?.mainKAD) +
                ' - ' +
                printInfo(response?.mainKADDescription)}
            </Descriptions.Item>
            { response?.isForeignSupplier ?
              <Descriptions.Item label="Συμπληρωματικοί ΚΑΔ">
                {printInfo(response?.additionalKAD)}
              </Descriptions.Item>  
            : <Descriptions.Item label="Συμπληρωματικοί ΚΑΔ">
              <div
                style={{
                  height: '100px',
                  display: 'flex',
                  flexDirection: 'column',
                  paddingTop: '16px',
                  paddingBottom: '16px',
                }}
              >
                <div style={{ flex: 1, overflow: 'auto' }}>
                  {supplementaryKads ? (
                    <div style={{ whiteSpace: 'pre-line' }}>
                      {printInfo(supplementaryKads)}
                    </div>
                  ) : (
                    '-'
                  )}
                </div>
              </div>
            </Descriptions.Item>}
            {!response?.isForeignSupplier && <Descriptions.Item label="Νομική Μορφή">
              {printInfo(response.companyLegalType)}
            </Descriptions.Item>}
            <Descriptions.Item label="Οδός - Αριθμός">
              {printInfo(response.abiStreetFull)}
            </Descriptions.Item>
            <Descriptions.Item label="Τ.Κ.">
              {typeof response?.abiTk !== 'object'
                ? printInfo(response?.abiTk)
                : '-'}
            </Descriptions.Item>
           {response?.isForeignSupplier ?
            <Descriptions.Item label="Πόλη">
              {printInfo(response.abiCity)}
            </Descriptions.Item>
            : 
            <Descriptions.Item label="Νoμός">
              {printInfo(response.abiPerfecture)}
             </Descriptions.Item>
            }
            {response?.isForeignSupplier ?
            <Descriptions.Item label="Χώρα"> 
              {printInfo(response.abiCountry)}
            </Descriptions.Item>
            : <Descriptions.Item label="Περιοχή"> 
              {printInfo(response.abiDistrict)}
            </Descriptions.Item>
            }
            <Descriptions.Item label="Τηλέφωνο">
              {printInfo(response.invMob)}
            </Descriptions.Item>
            <Descriptions.Item label="Ιστοχώρος">
              <TruncatedURL url={response.website} />
            </Descriptions.Item>
            <Descriptions.Item label="E-mail">
              {printInfo(response.invMail)}
            </Descriptions.Item>
          </Descriptions>
        </div>

        {response.isDirectSupplier && (
          <div
            style={{ width: '49%', display: 'flex', flexDirection: 'column' }}
          >
            <h2 className="basic-form-title" style={{ marginTop: '30px', marginBottom: '39px' }}>
              Σχετικά με τον Προμηθευτή
            </h2>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              <Row
                gutter={8}
                className="short-descr-investment-plan-wrapper "
                style={{ flex: 1 }}
              >
                <Col span={24} style={{ height: '100%' }}>
                  <TextArea
                    value={printInfo(response.marketing)}
                    bordered
                    readOnly
                    style={{
                      height: '100%',
                      minHeight: '15rem',
                      resize: 'none',
                    }}
                  />
                </Col>
              </Row>
              {!response?.isForeignSupplier && 
                <div className="mt-3 borders-rounded-green table-reduced-padding">
                <Row gutter={16}>
                  <Col span={24}>
                    <Table
                      dataSource={bankDetailsSource}
                      columns={bankDetailsColumns}
                      pagination={false}
                    />
                  </Col>
                </Row>
              </div>
              }
            </div>
          </div>
        )}
      </div>
      {response.isDirectSupplier && (
        <>
          <h2 className="basic-form-title mt-12">Διαχείριση Χρηστών</h2>
          <div className="mt-4 borders-rounded-blue">
            <Row gutter={16} className="">
              <Col span={24}>
                <Table
                  dataSource={response?.carrierUsers?.carrierUsers}
                  columns={carrierUsersColumns}
                  pagination={false}
                />
              </Col>
            </Row>
          </div>
        </>
      )}

      {/* contactPersonFlag true means legal representative is also contact person*/}
      <div style={{ display: 'flex' }}>
        <Descriptions
          title="Νόμιμος Εκπρόσωπος"
          bordered
          className="descriptions-table-graye"
          style={{ width: '49%', marginRight: '2%' }}
          column={1}
        >
          <Descriptions.Item label="Επώνυμο">
            {printInfo(response.legalSurname)}
          </Descriptions.Item>
          <Descriptions.Item label="Όνομα">
            {printInfo(response.legalName)}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Φ.Μ.">
            {printInfo(response.legalVat)}
          </Descriptions.Item>
          <Descriptions.Item label="Τηλέφωνο Επικοινωνίας">
            {printInfo(response.legalPhone)}
          </Descriptions.Item>
          <Descriptions.Item label="E-mail Επικοινωνίας">
            {printInfo(response.legalEmail)}
          </Descriptions.Item>
        </Descriptions>
        <Descriptions
          title="Υπεύθυνος Προγράμματος"
          bordered
          className="descriptions-table-graye"
          column={1}
          style={{ width: '49%' }}
        >
          <Descriptions.Item label="Επώνυμο">
            {printInfo(
              response.contactPersonFlag
                ? response.legalSurname
                : response.contactSurname
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Όνομα">
            {printInfo(
              response.contactPersonFlag
                ? response.legalName
                : response.contactName
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Φ.Μ.">
            {printInfo(
              response.contactPersonFlag
                ? response.legalVat
                : response.contactVat
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Τηλέφωνο Επικοινωνίας">
            {printInfo(
              response.contactPersonFlag
                ? response.legalPhone
                : response.contactPhone
            )}
          </Descriptions.Item>
          <Descriptions.Item label="E-mail Επικοινωνίας">
            {printInfo(
              response.contactPersonFlag
                ? response.legalEmail
                : response.contactEmail
            )}
          </Descriptions.Item>
        </Descriptions>
      </div>

      {(response.isDirectSupplier && !response?.isForeignSupplier) && (
        <div className="mt-12">
          <h2 className="basic-form-title">Περιοχή Δραστηριότητας</h2>
          <Row>
            {!isEmpty(response?.regionalUnitiesActivityArea) ? (
              <Col span={6}>
                <div className="mt-1 bold">Περιφερειακή Ενότητα</div>
                <div className="mt-2" name="regionalUnitiesActivityArea">
                  {response?.regionalUnitiesActivityArea?.map(value => (
                    <Tag>{value}</Tag>
                  ))}
                </div>
              </Col>
            ) : (
              <Col span={6}>
                <div className="mt-1 bold">Περιφερειακή Ενότητα</div>
                <div className="mt-2" name="regionalUnitiesActivityArea">
                  -
                </div>
              </Col>
            )}

            {!isEmpty(response?.municipalitiesActivityArea) ? (
              <Col span={6}>
                <div className="mt-1 bold">Δήμος</div>
                <div className="mt-2" name="municipalitiesActivityArea">
                  {response?.municipalitiesActivityArea?.map(value => (
                    <Tag>{value}</Tag>
                  ))}
                </div>
              </Col>
            ) : (
              <Col span={6}>
                <div className="mt-1 bold">Δήμος</div>
                <div className="mt-2" name="municipalitiesActivityArea">
                  -
                </div>
              </Col>
            )}
          </Row>
        </div>
      )}
    </div>
  );
};

export default BasicInfo;
